export const reverseStr = (str: string): string => str.split('').reverse().join('')
